import React from "react";

const pdfs = [
  { id: 1, url: "/sanstha_savidhan.pdf" },
  { id: 2, url: "/acadmic_calendar_rcoe.pdf" },
  { id: 3, url: "/syllabus.pdf" },
  { id: 5, url: "/smiti_land_documents.pdf" },
  { id: 6, url: "/smitidocnew.pdf" },
  // { id: 4, url: "/Staff_List_B-Ed.pdf" },
];

function PdfListPage() {
  return (
    <div style={styles.page}>
      {pdfs.map((pdf) => (
        <div key={pdf.id} style={styles.card}>
          <iframe
            src={pdf.url}
            title={`pdf-${pdf.id}`}
            style={styles.viewer}
          />
        </div>
      ))}
    </div>
  );
}

export default PdfListPage;

/* ───────────── Inline Styles ───────────── */

const styles = {
  page: {
    maxWidth: "1100px",
    margin: "0 auto",
    padding: "1rem",
    background: "#f8fafc",
  },
  card: {
    marginBottom: "2rem",
    borderRadius: "12px",
    overflow: "hidden",
    boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
    background: "#ffffff",
  },
  viewer: {
    width: "100%",
    height: "650px",
    border: "none",
  },
};
